import TablePagination from '@mui/material/TablePagination';
import React from 'react';

interface Props {
  totalRows: number;
  rowsPerPage: number;
  page: number;
  rowsPerPageOptions: Array<number>;
  onPageChanged: (newPage: number) => void;
  onRowsPerPageChanged: (rowsPerPage: number) => void;
}




export const TableFooter: React.FC<Props> = (props) => {
  const { totalRows, rowsPerPage, rowsPerPageOptions, page } = props;
  const { onPageChanged, onRowsPerPageChanged } = props;

  const onChangePage = (evt: unknown, newPage: number) => {
      onPageChanged(newPage);
  }
  
  const onChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
      onRowsPerPageChanged(parseInt(event.target.value, 10))
  }


  return (
    <TablePagination
      rowsPerPageOptions={rowsPerPageOptions}
      component="div"
      count={totalRows}
      rowsPerPage={rowsPerPage}
      page={page}
      onPageChange={onChangePage}
      onRowsPerPageChange={onChangeRowsPerPage}
    />
  )
};
